import React from 'react'
import Motorista from './Motorista';
import Filter from '../../../Auxiliar/Filter';
import Compliances from '../Compliance/Compliances';

const SelecionarMotoristas = () => {
  const [search, setSearch] = React.useState(false)
  const [dateOf, setDateOf] = React.useState('')
  const [dateFor, setDateFor] = React.useState('')
  const [options, setOptions] = React.useState({
    motoristas: { value: true, label: 'Motoristas', checked: true },
    compliances: { value: false, label: 'Compliances', checked: false },
  })

  return (
    <div className="card">
      <div className="card-body" id="card">
        <div className="d-flex align-items-start">
          <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Motoristas</h4>
          <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
        </div>
        <div>
          <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os motoristas do sistema</p>
        </div>
        <div className="row">
          {options.motoristas.value &&
            <Motorista dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
          {options.compliances.value &&
            <Compliances dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} owner={'motoristas'} searchFor='driver_id' />}
        </div>
      </div>
    </div>
  )
}

export default SelecionarMotoristas